export const glHeader = ['$window', function($window){
    return {
        link: function(scope, elem, attrs) {
            // let win = angular.element($window);
            // function checkState() {
            //     if (attrs.morph == 1) {
            //         if ($window.pageYOffset > 100 ) {
            //             scope.opaque = true;
            //         } else {
            //             scope.opaque = false;
            //         }
            //     } else {
            //         scope.opaque = true;
            //     }
            // }
            // checkState();
            // win.bind('scroll', function() {
            //     checkState();
            //     scope.$apply();
            // });
            scope.$watch('searchActive', function(val) {
                setTimeout(function(){
                    angular.element(document.querySelector('.search-input')).focus();
                }, 100)
            })
        }
    }
}];

// V4
function toggleThisOverlay(overlay) {
  var activeOverlay = document.querySelector('[data-overlay-active="true"]')
  var chatPlugin = document.querySelector('#knockDoorwayRoot')
  if (activeOverlay) {  
    delete activeOverlay.dataset.overlayActive
    chatPlugin && chatPlugin.toggleAttribute('hidden', false)
  }
  if (overlay && overlay !== activeOverlay) {
    overlay.dataset.overlayActive = true
    chatPlugin && chatPlugin.toggleAttribute('hidden', true)
  }
}

export const overlayToggle = function () {
  document.addEventListener('click', function(e) {
    if (e.target.hasAttribute('data-overlay-toggle')) {
      const overlay = e.target.dataset.overlayToggle && document.querySelector(e.target.dataset.overlayToggle)
      toggleThisOverlay(overlay)
      if (overlay) {
        var input = overlay.querySelector('input')
        if (input) {
          setTimeout(function() {
            input.focus()
          }, 300);
        }
      }
    }
  })
}
overlayToggle()
//
